import React from "react";

import BarChart from "components/pages/dashboard/chart/BarChart";
import useRevenueChart from "components/pages/dashboard/revenue_analytic/chart/useRevenueChart";

const RevenueChart = ({ data }) => {
  const { options, chartData } = useRevenueChart(data);

  return (
    <BarChart
      options={options}
      data={chartData}
      height={300}
      style={{ cursor: "pointer" }}
    />
  );
};

export default RevenueChart;
